import { environment } from '@environments/environment';

export const pageSize = 10;

export const noPro = environment.envName === 'local';

export const CUSTOME_BANNER_TORITO =
  environment.urlAssets + 'lottery/banner/CUSTOME_BANNER.gif';

export const VERTICAL_BANNER_TORITO =
  environment.urlAssets + 'lottery/banner/VERTICAL_BANNER.gif';

export const UNDER_DASHBOARD_BANNER_TORITO =
  environment.urlAssets + 'lottery/banner/UNDER_DASHBOARD_BANNER.gif';

export const SIDE_RIGHT_BANNER_TORITO =
  environment.urlAssets + 'lottery/banner/SIDE_RIGHT.gif';

export const SIDE_LEFT_2_BANNER_TORITO =
  environment.urlAssets + 'lottery/banner/SIDE_LEFT_2.gif';
